import VueQr from 'vue-qr'
import AppBar from '@/components/app-bar/AppBar.vue'
import AppBarSpace from '@/components/app-bar/AppBarSpace.vue'
import contestApi from '@/api/contest'

export default {
    name: 'MyContestRefereeCheckIn',
    components: {
        AppBar,
        AppBarSpace,
        VueQr,
    },
    data() {
        return {
            contestId: this.$route.params.contestId,
            qrcode: null
        }
    },
    created() {
        this.getPageInfo()
    },
    methods: {
        async getPageInfo() {
            try {
                let result = await contestApi.getDetail(this.contestId)
                this.qrcode = result.judgeSignin
            } catch (error) {
                this.$toast.fail(error.message)
            }
        }
    }
}
